import React from 'react'
import Campusgeniecomp from '../../components/caseComponent/campusgenieComp/canpusgenieComp'

const Campusgenie = () => {
  return (
    <div>
      <Campusgeniecomp />
    </div>
  )
}

export default Campusgenie
